import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, withStyles, AppBar, Typography, Toolbar } from 'material-ui';
import SeatSelectionHeaderStyles from './SeatSelectionHeaderStyles';
import ArrowLeftIcon from '../../../../icons/ArrowLeftIcon';
import Dictionary from '../../../../model/Dictionary';

const SeatSelectionHeader = ({ title, handleClose, seat, showSeat, classes }) => (
  <div style={{ flexGrow: 1 }}>
    <AppBar
      position='static'
      style={{
        width: '100%',
        backgroundColor: 'transparent',
        color: 'rgba(0, 0, 0, 0.54)',
      }}
    >
      <Toolbar>
        <IconButton color='inherit' onClick={handleClose} aria-label='Close'>
          <ArrowLeftIcon className='navbar-arrow-icon' color='rgba(0, 0, 0, 0.54)' />
        </IconButton>
        <Typography type='title' color='inherit' className={classes.flex}>
          {title}
        </Typography>
        {!showSeat ? (
          <span style={{ width: 30 }} />
        ) : !seat ? (
          <Typography type='title' color='inherit' style={{ fontSize: 14 }}>
            {Dictionary.seat.select}
          </Typography>
        ) : (
          <Typography type='title' color='inherit' style={{ fontSize: 14 }}>
            {Dictionary.seat.seat}&nbsp;{seat}
          </Typography>
        )}
      </Toolbar>
    </AppBar>
  </div>
);

SeatSelectionHeader.propTypes = {
  title: PropTypes.string,
  seat: PropTypes.string,
  showSeat: PropTypes.bool,
  handleClose: PropTypes.func,
  classes: PropTypes.object,
};

export default withStyles(SeatSelectionHeaderStyles)(SeatSelectionHeader);



// WEBPACK FOOTER //
// ./src/containers/seats/common/seatSelection/SeatSelectionHeader.js